import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/GlobalDesign.css';

const AdminNav = ({ mobileOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', JSON.stringify(newState));
    
    // Dispatcher un événement custom pour informer AdminLayout
    window.dispatchEvent(new CustomEvent('sidebarToggle', { 
      detail: { open: newState } 
    }));
  };

  const navigateTo = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'} ${mobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <img src="/logo.png" alt="Fluxivo" style={{height: '32px', width: 'auto', maxWidth: sidebarOpen ? '120px' : '32px', objectFit: 'contain', transition: 'max-width 0.2s'}} />
        </div>
        <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle sidebar">
          {sidebarOpen ? '◀' : '▶'}
        </button>
      </div>

      <div className="sidebar-menu">
        <button 
          className={`sidebar-link ${isActive('/admin/home')}`}
          onClick={() => navigateTo('/admin/home')}
          title="Tableau de bord"
        >
          <span className="sidebar-icon">🏠</span>
          {sidebarOpen && <span className="sidebar-text">Tableau de bord</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/users')}`}
          onClick={() => navigateTo('/admin/users')}
          title="Utilisateurs"
        >
          <span className="sidebar-icon">👥</span>
          {sidebarOpen && <span className="sidebar-text">Utilisateurs</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/revenue')}`}
          onClick={() => navigateTo('/admin/revenue')}
          title="Revenus"
        >
          <span className="sidebar-icon">💰</span>
          {sidebarOpen && <span className="sidebar-text">Revenus</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/receipts')}`}
          onClick={() => navigateTo('/admin/receipts')}
          title="Reçus"
        >
          <span className="sidebar-icon">🧾</span>
          {sidebarOpen && <span className="sidebar-text">Reçus</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/category-block')}`}
          onClick={() => navigateTo('/admin/category-block')}
          title="Blocage Catégories"
        >
          <span className="sidebar-icon">🚧</span>
          {sidebarOpen && <span className="sidebar-text">Blocage Catégories</span>}
        </button>

        <button 
          className={`sidebar-link ${isActive('/admin/channels')}`}
          onClick={() => navigateTo('/admin/channels')}
          title="Chaînes"
        >
          <span className="sidebar-icon">📺</span>
          {sidebarOpen && <span className="sidebar-text">Chaînes</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/xtream')}`}
          onClick={() => navigateTo('/admin/xtream')}
          title="Xtream Codes"
        >
          <span className="sidebar-icon">🎯</span>
          {sidebarOpen && <span className="sidebar-text">Xtream Codes</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/mac')}`}
          onClick={() => navigateTo('/admin/mac')}
          title="Activation MAC"
        >
          <span className="sidebar-icon">🔌</span>
          {sidebarOpen && <span className="sidebar-text">Activation MAC</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/app-activations')}`}
          onClick={() => navigateTo('/admin/app-activations')}
          title="Activation Apps"
        >
          <span className="sidebar-icon">📲</span>
          {sidebarOpen && <span className="sidebar-text">Activation Apps</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/test-tokens')}`}
          onClick={() => navigateTo('/admin/test-tokens')}
          title="Tokens Test"
        >
          <span className="sidebar-icon">🎁</span>
          {sidebarOpen && <span className="sidebar-text">Tokens Test</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/proxy-config')}`}
          onClick={() => navigateTo('/admin/proxy-config')}
          title="Config Proxy HLS"
        >
          <span className="sidebar-icon">⚙️</span>
          {sidebarOpen && <span className="sidebar-text">Proxy HLS</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/live-cdn')}`}
          onClick={() => navigateTo('/admin/live-cdn')}
          title="CDN Live"
        >
          <span className="sidebar-icon">🌐</span>
          {sidebarOpen && <span className="sidebar-text">CDN Live</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/mediamtx')}`}
          onClick={() => navigateTo('/admin/mediamtx')}
          title="MediaMTX"
        >
          <span className="sidebar-icon sidebar-icon-text">MTX</span>
          {sidebarOpen && <span className="sidebar-text">MediaMTX</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/notifications')}`}
          onClick={() => navigateTo('/admin/notifications')}
          title="Notification"
        >
          <span className="sidebar-icon">✉️</span>
          {sidebarOpen && <span className="sidebar-text">Notification</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/resellers')}`}
          onClick={() => navigateTo('/admin/resellers')}
          title="Revendeurs"
        >
          <span className="sidebar-icon">🤝</span>
          {sidebarOpen && <span className="sidebar-text">Revendeurs</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/reseller-settings')}`}
          onClick={() => navigateTo('/admin/reseller-settings')}
          title="Paramètres Adhésion"
        >
          <span className="sidebar-icon">🎫</span>
          {sidebarOpen && <span className="sidebar-text">Adhésion Revendeurs</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/withdrawals')}`}
          onClick={() => navigateTo('/admin/withdrawals')}
          title="Retraits"
        >
          <span className="sidebar-icon">💸</span>
          {sidebarOpen && <span className="sidebar-text">Retraits</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/credit')}`}
          onClick={() => navigateTo('/admin/credit')}
          title="Système de Crédit"
        >
          <span className="sidebar-icon">💳</span>
          {sidebarOpen && <span className="sidebar-text">Système de Crédit</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/pricing')}`}
          onClick={() => navigateTo('/admin/pricing')}
          title="Gestion des Prix"
        >
          <span className="sidebar-icon">💰</span>
          {sidebarOpen && <span className="sidebar-text">Gestion des Prix</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/promo-codes')}`}
          onClick={() => navigateTo('/admin/promo-codes')}
          title="Codes Promo"
        >
          <span className="sidebar-icon">🎟️</span>
          {sidebarOpen && <span className="sidebar-text">Codes Promo</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/payment-aggregators')}`}
          onClick={() => navigateTo('/admin/payment-aggregators')}
          title="Agrégateurs de paiement"
        >
          <span className="sidebar-icon">💳</span>
          {sidebarOpen && <span className="sidebar-text">Paiements</span>}
        </button>
        
        <button 
          className={`sidebar-link ${isActive('/admin/whatsapp')}`}
          onClick={() => navigateTo('/admin/whatsapp')}
          title="Relance WhatsApp"
        >
          <span className="sidebar-icon">📱</span>
          {sidebarOpen && <span className="sidebar-text">Relance WhatsApp</span>}
        </button>

        <button
          className={`sidebar-link ${isActive('/admin/bot-api-keys')}`}
          onClick={() => navigateTo('/admin/bot-api-keys')}
          title="Clés API Bot"
        >
          <span className="sidebar-icon sidebar-icon-text">API</span>
          {sidebarOpen && <span className="sidebar-text">Clés API Bot</span>}
        </button>

        <div className="sidebar-divider"></div>
        
        <button className="sidebar-link logout-btn" onClick={handleLogout} title="Déconnexion">
          <span className="sidebar-icon">🚪</span>
          {sidebarOpen && <span className="sidebar-text">Déconnexion</span>}
        </button>
      </div>
    </div>
  );
};

export default AdminNav;
